import type { TAddressFields, TCoordinatesFields, TAddressFieldsInput, TCoordinatesFieldsInput } from 'types/location';
import { ELocationMode } from 'types/location';

export interface ILocationPayload {
  coordinates?: Required<TCoordinatesFields>;
  address?: Required<TAddressFields>;
}

export const extractAddressFields = (data: TAddressFieldsInput): TAddressFields => {
  return {
    name: data.name ?? undefined,
    countryId: data.countryId ?? undefined,
    postCode: data.postCode ?? undefined,
    city: data.city ?? undefined,
    address: data.address ?? undefined,
  };
};

export const extractCoordinates = (coordinates: TCoordinatesFieldsInput): TCoordinatesFields => {
  return { lat: coordinates.lat ?? undefined, lng: coordinates.lng ?? undefined };
};

export const isAddressPopulated = (address: TAddressFields) => {
  return (
    Boolean(address.countryId) &&
    Boolean(address.name?.trim()) &&
    Boolean(address.postCode?.trim()) &&
    Boolean(address.city?.trim()) &&
    Boolean(address.address?.trim())
  );
};

export const isCoordinatesPopulated = (coordinates: TCoordinatesFields) => {
  return Boolean(coordinates.lat) && Boolean(coordinates.lng);
};

export const validateLocationByMode = (
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
) => {
  if (locationMode === ELocationMode.coordinates) {
    return isCoordinatesPopulated(coordinates);
  }
  return isAddressPopulated(address);
};

export const buildLocationPayload = (
  locationMode: ELocationMode,
  coordinates: TCoordinatesFields,
  address: TAddressFields,
) => {
  const payload: ILocationPayload = {};

  if (locationMode === ELocationMode.coordinates && isCoordinatesPopulated(coordinates)) {
    payload.coordinates = { lat: coordinates.lat as number, lng: coordinates.lng as number };
  } else if (locationMode === ELocationMode.address && isAddressPopulated(address)) {
    payload.address = {
      countryId: address.countryId as number,
      name: address.name as string,
      postCode: address.postCode as string,
      city: address.city as string,
      address: address.address as string,
    };
  }

  return payload;
};
